import { Modal } from '@a_team/ui-components';
import { Breakpoints } from '@ateams/components';
import { VideoPlayer } from '@src/components/VideoPlayer';
import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import RoleInfo from '../ApplyDetailsModalDrawer/RoleInfo';
import MissionRole from '@a_team/models/dist/MissionRole';
import AuthStore from '@src/stores/Auth';
import Profile from '@src/stores/Profile/Profile';
import { MissionLink } from '@a_team/models/dist/MissionObject';

interface ApplicationDetailsModalProps {
  open: boolean;
  onClose: () => void;
  videoURL?: string;
  onVideoPlay: () => void;
  description?: string;
  attachedLinks: MissionLink[] | undefined | null;
  auth: AuthStore;
  profile?: Profile;
  currentRole?: MissionRole;
}

const useStyles = createUseStyles({
  modal: {
    textAlign: 'start',
    padding: 0,
    width: '1080px !important',
    '& a': {
      color: '#6D00D7',
    },
  },
  content: {
    maxWidth: '680px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    marginBottom: 16,
  },
  linkInfo: {
    marginBottom: 12,
  },
  url: {
    marginRight: '20px',
  },
  [`@media (min-width: ${Breakpoints.md}px)`]: {
    modal: {
      padding: 30,
    },
  },
});

const ApplicationDetailsModal = ({
  open,
  onClose,
  videoURL,
  onVideoPlay,
  description,
  attachedLinks,
  profile,
  currentRole,
}: ApplicationDetailsModalProps): JSX.Element => {
  const styles = useStyles();

  const [loading, setLoading] = useState(true);

  const onVideoError = (error: Error) => {
    setLoading(false);
  };

  const onVideoReady = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!videoURL) setLoading(false);
  }, [videoURL]);

  return (
    <Modal
      variant="slideUp"
      isOpen={open}
      onClose={onClose}
      className={styles.modal}
      shouldHideGradientStroke={true}
    >
      <div>
        <div className={styles.content}>
          <h4 className={styles.title}>Mission Description and Role Details</h4>
          {profile && currentRole && (
            <RoleInfo profile={profile} currentRole={currentRole} />
          )}
          <div>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: `<p>${description?.replace(/\n\n/g, '</p><p>')}</p>`,
              }}
            />

            {attachedLinks &&
              attachedLinks.map((link, key) => {
                return (
                  <div className={styles.linkInfo} key={key}>
                    <span className={styles.url}>{link.title}</span>
                    <a rel="noreferrer" target="_blank" href={link.URL}>
                      {link.URL}
                    </a>
                    <br />
                  </div>
                );
              })}
          </div>
          {videoURL && (
            <div className={styles.right}>
              <h4>Video Description</h4>
              <VideoPlayer
                loading={loading}
                height={'300px'}
                url={videoURL}
                onPlay={onVideoPlay}
                onReady={onVideoReady}
                onError={onVideoError}
                width={'100%'}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ApplicationDetailsModal;
